import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';

const PanditjiList = () => {
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [nameQuery, setNameQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [pincodeQuery, setPincodeQuery] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const history = useHistory();
  const token = localStorage.getItem('authToken');
  const getData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/options`, {
        params: {
          page: currentPage,
          limit: 10,
          name: nameQuery,
         
        }
      },{
        headers: {
          Authorization: `Bearer ${token}`, 
        }
      });
  
      console.log("API Response:", response.data); // Debugging: Log the API response
  
      setCategories(response.data.selectedOptions);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching data:', error); // Debugging: Log the error
    }
  }



  useEffect(() => {
    getData();
  }, [currentPage, nameQuery]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNameSearch = (e) => {
    setNameQuery(e.target.value);
  };
 


  
  const handleDownload = () => {
    const fields = [
    "categoryId.name", "name","contactNo","email", "description","createdAt"
  ];
  const json2csvParser = new Parser({ fields });
  const csv = json2csvParser.parse(categories);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'panditJi_list.csv');
}


const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};
const formatDescription = (description) => {
  return description.length > 10 ? description.slice(0, 10) + '...' : description;
};
  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Pandit Ji List</h2>
        </div>
        <div className="d-flex justify-content-start">
          <div className="input-group m-b-10 col-lg-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Name"
              value={nameQuery}
              onChange={handleNameSearch}
            />

          </div>
          <div>
          <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Selected Category</th>
                <th>Name</th>
                <th>Contact No</th>
                <th>Email</th>
                <th>Description</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody >
              {categories.map((category, index) => {
                return (
                  <tr key={category.id}>
                    <td>{(currentPage - 1) * 10 + index + 1}</td>
                    <td>{category?.categoryId?.name}</td>
                    <td>{category.name}</td>
                    <td>{category.contactNo}</td>
                    <td>{category.email}</td>
                    <td>{formatDescription(category.description)}</td>
                    <td> {formatDate(category.createdAt)}</td>
                   
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(PanditjiList);
